import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WorkshopModel } from '../../models/workshop.model';
import { InformWayModel } from '../../../../shared/models/inform-way.model';
import { WorkshopService } from '../../services/workshop.service';
import { BasicInformationService } from '../../../../shared/services/basic-information.service';
import { PersianTitlesService } from '../../../../core/services/persian-titles.service';

@Component({
  selector: 'app-workshop-register',
  templateUrl: './workshop-register.component.html',
  styleUrls: ['./workshop-register.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WorkshopRegisterComponent implements OnInit, OnDestroy {
  @Input() workshopId: number;
  @Output() onHideWorkshopRegisteringPopup = new EventEmitter<boolean>();

  workshop: WorkshopModel;

  subscription: Subscription;
  informWaySubscription: Subscription;

  form: FormGroup;

  informWays: InformWayModel[];

  showPopup: boolean = false;
  loading: boolean = false;

  // Labels
  titleLabel: string;
  attendanceTypeLabel: string;
  informWayLabel: string;
  registerLabel: string;
  registerPromptLabel: string;
  questionsLabel: string;

  get popUpWith() {
    return window.innerWidth > 768 ? '700px' : '90%';
  }
  constructor(
    private workshopService: WorkshopService,
    private basicInformationService: BasicInformationService,
    private persianTitlesService: PersianTitlesService,
    private notifierService: NotifierService,
  ) {}

  ngOnInit() {
    this.initLabels();
    this.fetchWorkshop();
  }

  onHide() {
    this.showPopup = false;
    this.onHideWorkshopRegisteringPopup.emit(true);
  }

  onRegister() {
    if (this.form.valid) {
      this.loading = true;
      this.subscription = this.workshopService
        .registerOnWorkshop(this.workshop.id, this.form.value)
        .subscribe(
          () => {
            this.notifierService.notify(
              'success',
              this.persianTitlesService.Phrases
                .WorkshopRegistrationRegisteredAndApprovedSuccessfully,
            );
            this.showPopup = false;
            this.onHideWorkshopRegisteringPopup.emit(true);
            this.loading = false;
          },
          (error) => {
            if (error.error) {
              this.notifierService.notify('error', error.error.detail);
            } else {
              this.notifierService.notify(
                'error',
                this.persianTitlesService.Phrases.WorkshopRegisterError,
              );
            }
            this.loading = false;
          },
        );
    } else {
      this.notifierService.notify(
        'error',
        this.persianTitlesService.Phrases.FormValueError,
      );
    }
  }

  ngOnDestroy() {
    this.informWaySubscription?.unsubscribe();
    this.subscription?.unsubscribe();
  }

  private fetchWorkshop() {
    this.informWaySubscription = this.basicInformationService
      .getInformWays()
      .subscribe((data) => {
        this.informWays = data;
      });
    this.subscription = this.workshopService
      .getWorkshop(this.workshopId)
      .subscribe((workshop) => {
        this.workshop = workshop;
        this.initForm();
        this.form.patchValue({
          workshopId: this.workshop.id,
        });
        this.showPopup = true;
      });
  }

  private initForm() {
    this.form = new FormGroup({
      attendanceTypeId: new FormControl(null, Validators.required),
      informWayId: new FormControl(null, Validators.required),
      confirmed: new FormControl(false, Validators.requiredTrue),
      workshopId: new FormControl(null, Validators.required),
      questions: new FormControl(null),
    });
  }

  private initLabels() {
    this.titleLabel = this.persianTitlesService.Items.Register;
    this.attendanceTypeLabel = this.persianTitlesService.Items.AttendanceType;
    this.informWayLabel = this.persianTitlesService.Items.InformWay;
    this.questionsLabel = this.persianTitlesService.Phrases.EnterYourQuestions;
    this.registerLabel = this.persianTitlesService.Items.Register;
    this.registerPromptLabel = this.persianTitlesService.Phrases.RegisterPrompt;
  }
}
